import { CmsPageView } from '../components/CmsPageView';

export default function AboutUsPage() {
  return <CmsPageView code="ABOUT_US" fallbackTitle="About Us" />;
}
